import { format } from "date-fns";

export const  getFormattedDate = (dateString: string) => {
  // this method will return following format "12, Feb 2024"
  const formattedDate: string = format(new Date(dateString), "dd, MMM yyyy");
  return formattedDate;
};
export const formatDate = (dateString: string) => {
  // this method will return following format "July 14, 1995"
  const formattedDate: string = format(new Date(dateString), "dd, MMM yyyy");
  return formattedDate;
};

export const todayDate = new Date().toISOString().split("T")[0];


export const formatDateInput = (dateString: string) => {
  const formattedDate: string = format(new Date(dateString), "yyyy-MM-dd");
  return formattedDate;
};

export const CheckDateOfBirthInput = (dob: any) => {
  const today = new Date();
  const birthDate = new Date(dob);
  if (isNaN(birthDate.getTime())) {
    return false;
  }

  const ageDifference = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();
  const dayDifference = today.getDate() - birthDate.getDate();

  if (
    ageDifference > 18 ||
    (ageDifference === 18 && monthDifference > 0) ||
    (ageDifference === 18 && monthDifference === 0 && dayDifference >= 0)
  ) {
    return true;
  } else {
    return false;
  }
};
